import { useQuery } from "@tanstack/react-query";
import { timeEntryKeys } from "../time-entry.keys";
import { timeEntryApi } from "../service";

export function useTimeManagementDetail(id: number) {
  return useQuery({
    queryKey: timeEntryKeys.detail(id),
    queryFn: () => timeEntryApi.getTimeManagementById(id).then((r) => r.data),
    enabled: !!id,
  });
}
